export const vendorsTranslations = {
  ar: {
    title: 'الموردين',
    addNew: 'اضافة جديد',
    search: 'بحث',
    serial: 'التسلسل',
    name: 'الاسم',
    nbrTax: 'الرقم الضريبي',
    address: 'العنوان',
    branch: 'الفرع',
    edit: 'تعديل',
    delete: 'حذف',
    copy: 'نسخ',
    paste: 'لصق',
    view: 'عرض',
    list: 'قائمة',
    save: 'حفظ',
    cancel: 'إلغاء',
    noVendors: 'لا يوجد موردين',
    loading: 'جاري تحميل الموردين...',
    error: 'فشل تحميل الموردين',
    saveSuccess: 'تم حفظ المورد بنجاح',
    saveError: 'فشل حفظ المورد',
    deleteSuccess: 'تم حذف المورد بنجاح',
    deleteError: 'فشل حذف المورد',
    copySuccess: 'تم نسخ المورد',
    pasteSuccess: 'تم لصق المورد بنجاح',
    pasteError: 'لا يوجد مورد منسوخ',
    description: 'الوصف',
    selectBranch: 'اختر الفرع',
    isActive: 'نشط',
    isVisibleInPos: 'ظاهر في نقطة البيع',
    buildingNo: 'رقم المبنى',
    district: 'الحي',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    streetName: 'اسم الشارع',
    country: 'الدولة',
    additionalNo: 'الرقم الإضافي',
    registerNo: 'رقم السجل',
    previous: 'السابق',
    next: 'التالي',
    page: 'صفحة',
    of: 'من',
    showing: 'عرض',
    to: 'إلى',
    results: 'نتيجة',
    selectVendor: 'اختر المورد',
    noVendorsMatch: 'لا توجد موردين مطابقة للبحث',
    taxNo: 'الرقم الضريبي',
    addNewVendor: 'إضافة مورد جديد',
    createdNewVendorLog: 'تم إنشاء مورد جديد:',
    updatedVendorLog: 'تم تحديث مورد:',
    deletedVendorLog: 'تم حذف مورد:',
    copiedVendorLog: 'تم نسخ مورد:',
    pastedVendorLog: 'تم لصق مورد:',
    viewedVendorLog: 'عرض تفاصيل مورد:',
    noVendorSelected: 'لا يوجد مورد محدد',
    vendorCard: 'بطاقة المورد',
    printingCard: 'جاري طباعة البطاقة...',
    printedVendorCardLog: 'طباعة بطاقة مورد:',
    printCardError: 'فشل طباعة البطاقة',
    noDataToPrint: 'لا توجد بيانات للطباعة',
    yes: 'نعم',
    no: 'لا',
    totalVendors: 'إجمالي الموردين',
    activeVendors: 'الموردون النشطون',
    inactiveVendors: 'الموردون غير النشطين',
    printingList: 'جاري طباعة القائمة...',
    printListError: 'فشل طباعة القائمة',
    selectAtLeastOneColumn: 'يرجى اختيار عمود واحد على الأقل',
    generatingPdf: 'جاري توليد PDF...',
    pdfGeneratedSuccess: 'تم توليد PDF بنجاح',
    pdfGeneratedError: 'فشل توليد PDF',
    printList: 'طباعة القائمة',
    generatePdf: 'توليد PDF',
    vendorsList: 'قائمة الموردين',
    employee: 'الموظف',
    selectEmployee: 'اختر الموظف',
    alsoACustomer: 'هو أيضاً عميل',
    nameRequired: 'الاسم مطلوب',
    saving: 'جاري الحفظ...',
    printCard: 'طباعة البطاقة',
  },
  en: {
    title: 'Vendors',
    addNew: 'Add New',
    search: 'Search',
    serial: 'Serial',
    name: 'Name',
    nbrTax: 'Tax Number',
    address: 'Address',
    branch: 'Branch',
    edit: 'Edit',
    delete: 'Delete',
    copy: 'Copy',
    paste: 'Paste',
    view: 'View',
    list: 'List',
    save: 'Save',
    cancel: 'Cancel',
    noVendors: 'No vendors',
    loading: 'Loading vendors...',
    error: 'Failed to load vendors',
    saveSuccess: 'Vendor saved successfully',
    saveError: 'Failed to save vendor',
    deleteSuccess: 'Vendor deleted successfully',
    deleteError: 'Failed to delete vendor',
    copySuccess: 'Vendor copied',
    pasteSuccess: 'Vendor pasted successfully',
    pasteError: 'No vendor copied',
    description: 'Description',
    selectBranch: 'Select Branch',
    isActive: 'Active',
    isVisibleInPos: 'Visible in POS',
    buildingNo: 'Building No',
    district: 'District',
    city: 'City',
    postalCode: 'Postal Code',
    streetName: 'Street Name',
    country: 'Country',
    additionalNo: 'Additional No',
    registerNo: 'Register No',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    to: 'to',
    results: 'results',
    selectVendor: 'Select Vendor',
    noVendorsMatch: 'No vendors match your search',
    taxNo: 'Tax No',
    addNewVendor: 'Add New Vendor',
    createdNewVendorLog: 'Created new vendor:',
    updatedVendorLog: 'Updated vendor:',
    deletedVendorLog: 'Deleted vendor:',
    copiedVendorLog: 'Copied vendor:',
    pastedVendorLog: 'Pasted vendor:',
    viewedVendorLog: 'Viewed vendor details:',
    noVendorSelected: 'No vendor selected',
    vendorCard: 'Vendor Card',
    printingCard: 'Printing card...',
    printedVendorCardLog: 'Printed vendor card:',
    printCardError: 'Failed to print card',
    noDataToPrint: 'No data to print',
    yes: 'Yes',
    no: 'No',
    totalVendors: 'Total Vendors',
    activeVendors: 'Active Vendors',
    inactiveVendors: 'Inactive Vendors',
    printingList: 'Printing list...',
    printListError: 'Failed to print list',
    selectAtLeastOneColumn: 'Please select at least one column',
    generatingPdf: 'Generating PDF...',
    pdfGeneratedSuccess: 'PDF generated successfully',
    pdfGeneratedError: 'Failed to generate PDF',
    printList: 'Print List',
    generatePdf: 'Generate PDF',
    vendorsList: 'Vendors List',
    employee: 'Employee',
    selectEmployee: 'Select employee',
    alsoACustomer: 'Also a Customer',
    nameRequired: 'Name is required',
    saving: 'Saving...',
    printCard: 'Print Card',
  },
  fr: {
    title: 'Fournisseurs',
    addNew: 'Ajouter nouveau',
    search: 'Rechercher',
    serial: 'Série',
    name: 'Nom',
    nbrTax: 'Numéro fiscal',
    address: 'Adresse',
    branch: 'Succursale',
    edit: 'Modifier',
    delete: 'Supprimer',
    copy: 'Copier',
    paste: 'Coller',
    view: 'Voir',
    list: 'Liste',
    save: 'Enregistrer',
    cancel: 'Annuler',
    noVendors: 'Aucun fournisseur',
    loading: 'Chargement des fournisseurs...',
    error: 'Échec du chargement des fournisseurs',
    saveSuccess: 'Fournisseur enregistré avec succès',
    saveError: 'Échec de l\'enregistrement du fournisseur',
    deleteSuccess: 'Fournisseur supprimé avec succès',
    deleteError: 'Échec de la suppression du fournisseur',
    copySuccess: 'Fournisseur copié',
    pasteSuccess: 'Fournisseur collé avec succès',
    pasteError: 'Aucun fournisseur copié',
    description: 'Description',
    selectBranch: 'Sélectionner la succursale',
    isActive: 'Actif',
    isVisibleInPos: 'Visible au PDV',
    buildingNo: 'Numéro du bâtiment',
    district: 'Quartier',
    city: 'Ville',
    postalCode: 'Code postal',
    streetName: 'Nom de la rue',
    country: 'Pays',
    additionalNo: 'Numéro supplémentaire',
    registerNo: 'Numéro d\'enregistrement',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
    showing: 'Affichage',
    to: 'à',
    results: 'résultats',
    employee: 'Employé',
    selectEmployee: 'Sélectionner un employé',
  },
}


